<div class=" container-fluid py-3 left-menu-space" id="divMainContainer" role="main">
  <div class="page-title-box d-sm-flex justify-content-between bd-highlight pt-1">
    <h4 class="mb-0 f-bold-dubai text-secondary pb-4">My Dashboard</h4>
    <div class="page-title-right pb-4">
      <a class="btn btn-success text-white py-2 px-3" (click)="openAddModal(template,0)"><i class="fa fa-plus pr-1"></i> NEW MEETING MINUTES</a>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6 res-mb-25">
      <div class="card card-custom rounded pt-2 h-100">
        <div class="card-header pt-3 pb-0 border-bottom-0">
          <div class="float-right pt-1 no-pt-0-res"><a (click)="redirectMeetingMinutes('published')" class="text-secondary f-regular-dubai">View All</a></div>
          <h4 class="card-title mb-0 text-secondary">Newly Published Minutes</h4>
        </div>        
        <div class="card-body">
          <div class="loader-bg" *ngIf="isLoader"></div>
          <div class="border rounded bg-white py-4 text-center text-muted h-100 w-100 d-table mb-3" *ngIf="(lstMOMDashboard_PartofMeetings.length ===0 || lstMOMDashboard_PartofMeetings== null) && !isLoader">
            <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
            <h5 class="align-middle d-table-cell">No Data Available</h5>
          </div>
          <div class="rounded bg-white border-d-show" *ngFor="let item of lstMOMDashboard_PartofMeetings">
            <div class="border-all">
              <div class="py-3 px-3">
                <div class="row">
                  <h6 class="f-bold-dubai col-sm-9 col-lg-11 pointer" (click)="openEditModal(template1,item.genInfoAtdUno)" [title]="item.subjectAtd"> {{  (item.subjectAtd| truncatetext:65:0)}}</h6>
                  <a *ngIf="item.impCheck == true" (click)="openEditModal(template1,item.genInfoAtdUno,'view')" class="col-3 col-lg-1 text-right pointer text-danger px-2 tmm-5" title="Important"><i class="la la-info-circle fa-2x mx-1"></i></a>
                </div>
                <div class="p-0 sm-small-size">
                  <span class="pr-2"><i class="la la-calendar-o fa-lg ml-minus-3"></i><span class="d-day">{{item.meetingDate |  date:'EEE'}} </span>  {{item.meetingDate |  date:'dd/MM/yyyy'}}  <span class="d-time">{{item.startTime | timeFormat}} - {{item.endTime | timeFormat}}</span></span> |  <span class="px-2">
                    <i class="la la-map-marker fa-lg"></i>
                    <span *ngIf="item.meetingRoom.toLowerCase().indexOf('http')==-1">{{item.meetingRoom ===''?'NA':item.meetingRoom}}</span>
                    <a target="_blank" class="text-primary" href="{{item.meetingRoom}}" *ngIf="item.meetingRoom.toLowerCase().indexOf('http')!=-1">{{item.meetingRoom ===''?'NA':item.meetingRoom}}</a>
                  </span> <span class="px-0 d-block"><b class="text-secondary">Initiator:</b> {{item.initiator}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card card-custom rounded pt-2 h-100">
        <div class="card-header pt-3 pb-0 border-bottom-0">
          <div class="float-right pt-1 no-pt-0-res"><a (click)="redirectMeetingMinutes('approval')" class="text-secondary f-regular-dubai">View All</a></div>
          <h4 class="card-title mb-0 text-secondary">Minutes For Review/Approval</h4>

        </div>
        <div class="card-body">
          <div class="loader-bg" *ngIf="isLoader"></div>
          <div class="border rounded bg-white py-4 text-center text-muted h-100 w-100 d-table mb-3"
               *ngIf="(lstMOMDashboard_MyActionItems.length ===0 || lstMOMDashboard_MyActionItems== null)&& !isLoader ">
            <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
            <h5 class="align-middle d-table-cell">No Data Available</h5>
          </div>
          <div class="rounded bg-white border-d-show" *ngFor="let item of lstMOMDashboard_MyActionItems">
            <div class="border-all">
              <div class=" py-3 px-3 ">
                <div class="row">
                  <h6 class="f-bold-dubai col-sm-6 col-lg-8  col-xl-8 col-md-6 pointer" (click)="openEditModal(template1,item.genInfoAtdUno)">{{item.subjectAtd}}</h6>
                  <div class="col-sm-6 col-xl-4 col-md-6 col-lg-4 pb-2">
                    <button type="button"  *ngIf="item.approvalStatus =='Under Review' || item.approvalStatus =='Reviewed'" (click)="openEditModal(template1,item.genInfoAtdUno,'view')" class="float-sm-right btn btn-sm btn-outline-warning py-0 tmm-3">{{item.approvalStatusView}}</button>
                    <button type="button"  *ngIf="item.approvalStatus =='Approved'|| item.approvalStatus == 'Pending Approval'"(click)="openEditModal(template1,item.genInfoAtdUno,'view')" class="float-sm-right btn btn-sm btn-outline-primary py-0 tmm-3">{{item.approvalStatusView}}</button>
                  </div>
                </div>
                <div class="p-0 sm-small-size">
                  <span class="pr-2"><i class="la la-calendar-o fa-lg ml-minus-3"></i><span class="d-day">{{item.meetingDate |  date:'EEE'}} </span>{{item.meetingDate |  date:'dd/MM/yyyy'}} <span class="d-time">{{item.startTime | timeFormat}} - {{item.endTime | timeFormat}}</span></span> |  <span class="px-2">
                    <i class="la la-map-marker fa-lg"></i>
                    <span *ngIf="item.meetingRoom.toLowerCase().indexOf('http')==-1">{{item.meetingRoom ===''?'NA':item.meetingRoom}}</span>
                    <a target="_blank" class="text-primary" href="{{item.meetingRoom}}" *ngIf="item.meetingRoom.toLowerCase().indexOf('http')!=-1">{{item.meetingRoom ===''?'NA':item.meetingRoom}}</a>
                  </span> <span class="px-0 d-block"><b class="text-secondary">Initiator:</b> {{item.initiator}}</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6 my-4">
      <div class="card card-custom rounded pt-2 h-100">
        <div class="card-header pt-3 pb-0 border-bottom-0">
          <div class="float-right pt-1 no-pt-0-res"><a routerLink="#meetingofminutes" (click)="redirectMeetingMinutes('createdby')" class="text-secondary f-regular-dubai">View All</a></div>
          <h4 class="card-title mb-0 text-secondary">Minutes Created by Me</h4>
        </div>
        <div class="card-body">
          <div class="loader-bg" *ngIf="isLoader"></div>
          <div class="border rounded bg-white py-4 text-center text-muted h-100 w-100 d-table mb-3"               *ngIf="(lstMOMDashboard_MyMeetings.length ===0 || lstMOMDashboard_MyMeetings== null)&& !isLoader ">
            <!--<img src="{{noDataImage}}"  class="img-fluid" alt="No Data" />-->
            <h5 class="align-middle d-table-cell">No Data Available</h5>
          </div>
          <div class="rounded bg-white border-d-show" *ngFor="let item of lstMOMDashboard_MyMeetings">
            <div class="border-all">
              <div class=" py-3 px-3 ">
                <div class="row">
                  <ng-container *ngIf="item.approvalStatus=='Draft'; else newDeb">
                    <h6 class="f-bold-dubai col-sm-8 col-md-6 col-lg-10 mb-1" style="cursor:pointer;" (click)="openAddModal(template,item.genInfoAtdUno)" [title]="item.subjectAtd">{{  (item.subjectAtd| truncatetext:75:0)}} </h6>
                  </ng-container>
                  <ng-template #newDeb>
                    <h6 class="f-bold-dubai col-sm-8 col-md-6 col-lg-10 mb-1" style="cursor:pointer;" (click)="openEditModal(template1,item.genInfoAtdUno,'view')" [title]="item.subjectAtd">{{  (item.subjectAtd| truncatetext:75:0)}} </h6>
                  </ng-template>
                  
                  <div class="col-sm-4 col-md-6 col-lg-2">
                    <!--<button type="button" (click)="openEditModal(template1,item.genInfoAtdUno,'view')" class="float-sm-right ml-1  btn btn-sm btn-outline-warning py-0 tmm-3  mb-2">{{item.approvalStatus}}</button>-->
                    <button type="button" *ngIf="item.approvalStatus=='Draft'" (click)="openAddModal(template,item.genInfoAtdUno)" class="float-sm-right btn btn-sm ml-md-1  btn-outline-secondary py-0 tmm-3  mb-2">Edit</button>
                    <button type="button" (click)="openEditModal(template1,item.genInfoAtdUno,'view')" *ngIf="item.published==6" class="float-sm-right ml-md-1 btn btn-sm btn-outline-success py-0 tmm-3">Publish</button>

                  </div>
                </div>
                <div class="p-0 sm-small-size">
                  <span class="pr-2"><i class="la la-calendar-o fa-lg ml-minus-3"></i><span class="d-day">{{item.meetingDate |  date:'EEE'}} </span>{{item.meetingDate |  date:'dd/MM/yyyy'}} <span class="d-time">{{item.startTime | timeFormat}} - {{item.endTime | timeFormat}}</span></span> |  <span class="px-2">
                    <i class="la la-map-marker fa-lg"></i>
                    <span *ngIf="item.meetingRoom.toLowerCase().indexOf('http')==-1">{{item.meetingRoom ===''?'NA':item.meetingRoom}}</span>
                    <a target="_blank" class="text-primary" href="{{item.meetingRoom}}" *ngIf="item.meetingRoom.toLowerCase().indexOf('http')!=-1">{{item.meetingRoom ===''?'NA':item.meetingRoom}}</a>
                  </span> <span class="px-2 d-block"><span *ngIf="item.approvalStatus =='Draft'" class="text-secondary"> {{item.approvalStatus}}</span><span  class="text-warning" *ngIf="item.approvalStatus =='Under Review' || item.approvalStatus =='Reviewed'"> {{item.approvalStatusView}}</span><span class="text-primary" *ngIf="item.approvalStatus =='Approved'|| item.approvalStatus == 'Pending Approval'"> {{item.approvalStatusView}}</span><span class="text-success" *ngIf="item.approvalStatus =='Published'"> {{item.approvalStatus}}</span></span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6 my-4">
      <div class="card card-custom active rounded pt-2 h-100">
        <div class="card-header pt-3 pb-0 border-bottom-0">
          <div class="float-right pt-1 no-pt-0-res"><a routerLink="/meetingaction" class="text-secondary f-regular-dubai">View All</a></div>
          <h4 class="card-title mb-0 text-secondary">Action Points Assigned to Me</h4>
        </div>
        <div class="card-body">
          <div class="loader-bg" *ngIf="isLoader"></div>
          <div class="border rounded bg-white py-4 text-center text-muted h-100 w-100 d-table mb-3"
               *ngIf="(myTaskList.length ===0 || myTaskList== null)&& !isLoader ">
            <!--<img src="{{noDataImage}}"  class="img-fluid" alt="No Data" />-->
            <h5 class="align-middle d-table-cell">No Data Available</h5>
          </div>
          <div class="border-d-show" *ngFor="let agenda of myTaskList">
            <div class="border-all bg-white">
              <div class="py-3 px-3">
                <div class="row">
                  <div class="col-sm-7">
                    <h6 class="f-bold-dubai" style="cursor:pointer;" (click)="openActionPointModal(templateActionPoint,agenda.genInfoAtdUno)" [title]="agenda.subject"> {{  (agenda.subject| truncatetext:45:0)}}</h6>
                    <p class="text-secondary mb-0 " >{{  (agenda.note| truncatetext:90:0)}}</p>
                  </div>
                  <div class="col-sm-5 text-sm-right">
                    <span class="d-block  pb-2 tmm-3" style="cursor:pointer;" (click)="openActionPointModal(templateActionPoint,agenda.genInfoAtdUno)">
                      <span *ngIf="agenda.progress ==0" class="text-primary">Not Started</span>
                      <span class="text-primary" *ngIf="agenda.progress ==1">In Progress</span>
                      <span class="text-success" *ngIf="agenda.progress ==2">Completed</span>
                      <span class="text-primary" *ngIf="agenda.progress ==3">Waiting on others</span>
                      <span class="text-primary" *ngIf="agenda.progress ==4">Deferred</span>
                    </span>
                    <span class="d-block text-secondary" *ngIf="agenda.dueDate">Due Date {{agenda.dueDate | date:'EEE'}} {{agenda.dueDate | date:'dd/MM/yyyy'}}</span>
                    <span class="d-block text-secondary text-danger" *ngIf="!agenda.dueDate">Due - TBD </span>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div style="display:none">
      <quill-editor theme="snow" id="note" class="custom-form-control" style="background-color:#f1f1f1"
              name="note"  placeholder="Enter your text here">
</quill-editor>
    </div>
  </div>
</div>
<ng-template #templateActionPoint>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">Action Points Assigned to Me</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalActionPoint.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row" *ngIf="agendaInfo">
      <div class="col-md-6 py-2"><img class="img-fluid" src="\assets\v2\img\notes.jpg" /> {{agendaInfo.subjectAtd}}</div>
      <div class="col-md-6 py-2"><img class="img-fluid" src="\assets\v2\img\meeting.jpg" /> {{agendaInfo.meetingName}}</div>
      <div class="col-md-12 py-2"><img class="img-fluid" src="\assets\v2\img\date.jpg" /> <span class="d-day"> {{agendaInfo.meetingDate |  date:'MMM'}}</span>   {{agendaInfo.meetingDate |  date:'dd/MM/yyyy'}}  <span class="d-time"> {{agendaInfo.startTime | timeFormat}} - {{agendaInfo.endTime | timeFormat}}</span></div>
      <div class="col-md-6 py-2"><img class="img-fluid" src="\assets\v2\img\location.jpg" /> {{agendaInfo.meetingRoom !=''?agendaInfo.meetingRoom:'NA'}}</div>
      <div class="col-md-6 py-2"><img class="img-fluid" src="\assets\v2\img\location.jpg" /> {{agendaInfo.meetingLocation !=''?agendaInfo.meetingLocation:'NA'}}</div>
    </div>

    

  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn btn-outline-secondary border-0 bg-white text-secondary f-bold-dubai mx-3" (click)="modalActionPoint.hide()">Cancel</button>
    <button type="button" class="btn btn-success" (click)="openEditModal(template1,agendaInfo.genInfoAtdUno,'view');modalActionPoint.hide();" >View Meeting </button>
  </div>
</ng-template>

<ng-template #template1>
  <div class="modal-header p-0 border-0">
    <div class="custom-tab d-block w-100">
      <button type="button" class="close hide close-abs pull-right text-right" id="editclose" name="editclose" #editclose aria-label="Close" (click)="modalRef.hide();">
        <span aria-hidden="true"></span>
      </button>

    </div>
  </div>
    <app-view-meeting pagetype="MEETING" [viewType]="viewType" [mid]="mid" [inpUserList]="UserList" (editPopUpClose)="getPopUpOutput($event)"></app-view-meeting>
  

</ng-template>

<ng-template #template>
  <div class="modal-header pb-0 border-0">
    <div class="custom-tab d-block w-100">
      <h4 class="modal-title text-left px-2 f-bold-dubai pb-3">{{modalText}}</h4>
      <!--<small class="px-2"><a class="text-secondary" (click)="modalRef.hide();"><i class="ti ti-arrow-left"></i> Back to Meeting Minutes</a></small>-->
      <button type="button" class="close close-abs text-right" id="addclose" name="addclose" #addclose aria-label="Close" (click)="modalRef.hide();">
        <span aria-hidden="true"><i class="la la-close"></i></span>
      </button>

    </div>
  </div>
    <app-add-meeting pagetype="MEETING" [meetingEditUno]="meetingEditUno" [inpUserList]="UserList" (editPopUpClose)="getPopUpOutput($event)"></app-add-meeting>
</ng-template>

<!--<app-footer></app-footer>-->
